import { Injectable } from '@angular/core';

@Injectable()
export class NavbarService {
  public toggleSideNav = false
  constructor() { }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/navbar.service.ts